import React from 'react';
import { Chart, ChartOption } from '@/components/Base/Chart.tsx';
import { Box } from '@mui/material';
import { formatLargeNumber } from '@/utils/formatLargNumber';

const ColumnChartEvolutionInadimplencia = ({ selectedData }) => {
  if (!selectedData) return null;

  const months = selectedData.valor_score_meses.map((item) => item.nome);
  const valorRealData = selectedData.valor_score_meses.map((item) => item.valor);
  const percentualInadimplenciaData = selectedData.valor_score_meses.map((item) => item.valor_secundario);

  const option = {
    title: {
      text: 'Comparativo de inadimplência',
      padding: [16, 5, 5, 23],
      textStyle: {
        fontSize: '14px',
      },
    },
    legend: {
      data: ['Valor Real', 'Percentual de Inadimplência'],
      right: '0',
      padding: [16, 23, 5, 5],
    },
  
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999',
        },
      },
      formatter: (params) => {
        const valorReal = params[0].data;
        const percentualInadimplencia = params[1].data;
        return `
          <div>
            <strong>${params[0].name}</strong><br/>
            Valor Real: ${formatLargeNumber(valorReal)}<br/>
            Percentual de Inadimplência: ${percentualInadimplencia.toFixed(2)}%
          </div>
        `;
      },
    },
    yAxis: [
      {
        type: 'value',
        name: 'Valor',
      },
      {
        type: 'value',
        name: 'Percentual',
        axisLabel: {
          formatter: '{value}%',
        },
      },
    ],
    xAxis: {
      type: 'category',
      data: months,
      axisLabel: {
        rotate: 20,
        formatter: (value, index) => {
          return `{percent|${percentualInadimplenciaData[index].toFixed(0)}%}\n{value|${value}}`; // Inverter a posição
        },
        rich: {
          percent: {
            fontSize: 12,
            color: '#000',
            fontWeight: 'bold',
            padding: [15, 0, 0, 0],
          },
          value: {
            fontSize: 12,
            color: '#000',
            padding: [5, 0, 0, 0],
          },
        },
      },
    },
    series: [
      {
        name: 'Valor Real',
        type: 'bar',
        stack: 'a',
        data: valorRealData,
        itemStyle: {
          borderRadius: [10, 10, 0, 0],
          color: 'rgba(252, 159, 159, 1)',
        },
        label: {
          show: true,
          formatter: (params) => formatLargeNumber(Number(params.value)),
          position: 'top',
          backgroundColor: 'rgba(246, 190, 51, 1)',
          padding: [5, 10],
          borderRadius: [5],
        },
      },
      {
        name: 'Percentual de Inadimplência',
        type: 'line',
        smooth: true,
        yAxisIndex: 1,
        data: percentualInadimplenciaData,
        lineStyle: {
          color: 'black',
          width: 2,
        },
      },
    ],
  } as ChartOption;
  
  

  return (
    <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }} height={'400px'}>
      <Chart option={option} />
    </Box>
  );
};

export default ColumnChartEvolutionInadimplencia;
